import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import { createNamespacedHelpers } from "vuex";

const preciousMetals = {
  namespaced: true,
  state: () => ({
    data: null,
    error: null,
  }),
  getters: {
    pricesArray: (state) =>  Object.values(state.data).slice(0,3)

  },
  mutations: {
    FETCH_SUCCESS(state, payload) {
      if (payload.updated_at) {
        // multiplied by 1000 so that the argument is in milliseconds, not seconds.
        const localDate = new Date(payload.updated_at * 1000);
        if (localDate) {
          payload.updated_at = localDate;
        }
        else {
          payload.updated_at = null;
        }
      }
      state.error = null;
      state.data = payload;
    },

    FETCH_ERROR(state, error) {
      state.error = error;
    },
  },

  actions: {
    async fetch({ commit }) {
      try {
        const data = extractDataAxios(await window.axios.get('/api/metal-prices'));
        // we have updated_at timestamp in unix, let make it javascript date
        if (data) {
          commit('FETCH_SUCCESS', data);
        }
      }
      catch (e) {
        console.error(e);
        commit('FETCH_ERROR', extractErrorMessageAxios(e));
      }
    }
  },
}

const { mapState, mapActions, mapMutations, mapGetters } = createNamespacedHelpers('preciousMetals');

export { mapState, mapActions, mapMutations, mapGetters };

export default preciousMetals;